"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const firestore_1 = require("firebase/firestore");
const firestore_2 = require("@react-query-firebase/firestore");
const moment_1 = tslib_1.__importDefault(require("moment"));
const keyFactory_1 = require("../../Firestore-Query/keyFactory");
/**
 * Permite obtener los appointments de un doctor
 * @param uid uid del doctor
 */
function specialistAppointments(firestore, uid, type, country) {
    const appointmentRef = (0, firestore_1.collection)(firestore, `assignations/${type}/${country}`);
    const appointmentQuery = (0, firestore_1.query)(appointmentRef, (0, firestore_1.where)("state", "in", ["FREE"]), (0, firestore_1.where)("uid", "==", uid));
    return (0, firestore_2.useFirestoreQueryData)(keyFactory_1.FirestoreKeys.Especialista({
        name: "SpecialistAppointments",
        path: `assignations/${type}/${process.env.REACT_APP_COUNTRY}`
    }, [country, type, uid]), appointmentQuery, {}, {
        select: (Appointments) => {
            if (Appointments) {
                const today = (0, moment_1.default)();
                return Appointments.filter((appointment) => {
                    if (appointment.timestamps &&
                        appointment.timestamps.dt_assignation &&
                        appointment.timestamps.dt_assignation instanceof firestore_1.Timestamp) {
                        const moment_assignation = (0, moment_1.default)(appointment.timestamps.dt_assignation.toDate());
                        return moment_assignation.isSameOrAfter(today);
                    }
                    else {
                        console.warn("appointment FREE without timestamp.dt_assignation, check by uid:", appointment.uid);
                    }
                });
            }
        },
    });
}
exports.default = specialistAppointments;
